import { render, staticRenderFns } from "./CorteSuprema.vue?vue&type=template&id=41507a4a&"
import script from "./CorteSuprema.vue?vue&type=script&lang=js&"
export * from "./CorteSuprema.vue?vue&type=script&lang=js&"
import style0 from "vue-slim-tabs/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./CorteSuprema.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports